(function () {
  function initialize() {
    var bar = document.getElementById('gb-bar');
    var dialog = document.getElementById('fd-cart-peek');
    var template = document.getElementById('fd-cart-peek-template');
    if (!bar || !dialog || !template || bar.dataset.peekReady) return;
    bar.dataset.peekReady = 'true';
    var fragment = template.content.cloneNode(true);
    var toggle = fragment.querySelector('#fd-cart-peek-toggle');
    var heading = fragment.querySelector('.fd-cart-peek__heading');
    var content = fragment.querySelector('.fd-cart-peek__content');
    var pinnedSubtotal = fragment.querySelector('.fd-cart-peek__pinned-subtotal');
    var checkout = bar.querySelector('#gb-bar-checkout');
    checkout.before(toggle);
    bar.querySelector('.gb-bar__inner').prepend(heading);
    bar.querySelector('.gb-bar__foot').before(content);
    bar.querySelector('.gb-bar__foot').prepend(pinnedSubtotal);
    document.body.append(dialog);
    var status = content.querySelector('.fd-cart-peek__status');
    var retry = content.querySelector('.fd-cart-peek__retry');
    var list = content.querySelector('.fd-cart-peek__items');
    var subtotal = content.querySelector('.fd-cart-peek__subtotal');
    var shipping = content.querySelector('[data-peek-shipping]');
    var compactShipping = shipping.cloneNode(true);
    compactShipping.removeAttribute('role');
    bar.querySelector('.gb-bar__totals').after(compactShipping);
    var home;
    var requestVersion = 0;
    var closeTimer;
    var lastRender;
    var lastCart;

    function textElement(tag, className, text) {
      var element = document.createElement(tag);
      element.className = className;
      element.textContent = text;
      return element;
    }
    function render(cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart');
      lastCart = cart;
      var signature = JSON.stringify(cart);
      if (signature === lastRender) return;
      lastRender = signature;
      var active = document.activeElement;
      var activeKey = active && active.dataset.peekKey;
      var activeAction = active && active.dataset.peekAction;
      var money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart.currency || 'USD'});
      toggle.querySelector('[data-peek-count]').textContent = cart.item_count;
      list.replaceChildren();
      cart.items.forEach(function (item) {
        var row = textElement('li', 'fd-cart-peek__item', '');
        var image = document.createElement('img');
        image.className = 'fd-cart-peek__image';
        image.width = 62; image.height = 40; image.alt = '';
        var src = window.FDCartImage(item);
        image.decoding = 'async';
        if (src) image.src = src;
        else image.style.visibility = 'hidden';
        var info = document.createElement('div');
        info.className = 'fd-cart-peek__info';
        var title = item.product_title || item.title;
        var numberedCar = title.match(/^(?:The\s+)?Fidget\s*Drifter\s+(003|004)$/i);
        var model = numberedCar && (item.properties && item.properties.Model || numberedCar[1]);
        var name = model || title;
        if (item.variant_title && item.variant_title !== 'Default Title') name += ' ' + item.variant_title;
        info.append(textElement('strong', 'fd-cart-peek__name', name));
        Object.keys(item.properties || {}).forEach(function (key) {
          if (key !== 'Model' && key.charAt(0) !== '_' && item.properties[key]) info.append(textElement('p', 'fd-cart-peek__detail', key + ': ' + item.properties[key]));
        });
        var prices = textElement('div', 'fd-cart-peek__unit-price', '');
        if (item.original_price > item.final_price) prices.append(textElement('s', '', money.format(item.original_price / 100)));
        prices.append(textElement('strong', '', item.locked ? dialog.dataset.included : money.format(item.final_price / 100)));
        if (!item.locked) prices.append(textElement('span', '', dialog.dataset.each));
        info.append(prices);
        var actions = textElement('div', 'fd-cart-peek__item-actions', '');
        if (!item.locked) {
          var stepper = textElement('div', 'fd-cart-peek__stepper', '');
          function control(action, text, label) {
            var button = textElement('button', 'fd-cart-peek__' + action, text);
            button.type = 'button';
            button.dataset.peekKey = item.key;
            button.dataset.peekAction = action;
            button.setAttribute('aria-label', label + ' ' + name);
            return button;
          }
          var minus = control('decrease', '−', dialog.dataset.decrease);
          var plus = control('increase', '+', dialog.dataset.increase);
          plus.disabled = item.can_increase === false || item.key.indexOf('addon:') === 0;
          var quantity = textElement('span', 'fd-cart-peek__quantity', String(item.quantity));
          quantity.setAttribute('aria-label', dialog.dataset.quantity + ' ' + item.quantity);
          stepper.append(minus, quantity, plus);
          var remove = control('remove', dialog.dataset.remove, dialog.dataset.remove);
          actions.append(stepper, remove);
        } else actions.append(textElement('span', 'fd-cart-peek__detail', '×' + item.quantity));
        info.append(actions);
        row.append(image, info);
        list.append(row);
      });
      status.textContent = cart.items.length ? '' : dialog.dataset.empty;
      retry.hidden = true;
      subtotal.hidden = !cart.items.length;
      content.querySelector('[data-peek-total]').textContent = money.format(cart.total_price / 100);
      var domestic = dialog.dataset.country === 'US' && cart.currency === 'USD';
      var freeShipping = domestic && Number(cart.total_price) >= 2200;
      [shipping, compactShipping].forEach(function (line) {
        line.textContent = domestic ? (freeShipping ? dialog.dataset.freeShipping : dialog.dataset.shippingOffer) : dialog.dataset.internationalShipping;
        line.classList.toggle('is-free', freeShipping);
      });
      var original = content.querySelector('[data-peek-original]');
      var originalTotal = Number(cart.original_total_price || 0);
      pinnedSubtotal.hidden = !cart.items.length;
      pinnedSubtotal.querySelector('[data-peek-pinned-total]').textContent = money.format(cart.total_price / 100);
      pinnedSubtotal.querySelector('[data-peek-savings]').textContent = money.format(Math.max(0, originalTotal - cart.total_price) / 100);
      original.hidden = originalTotal <= cart.total_price;
      original.textContent = original.hidden ? '' : money.format(originalTotal / 100);
      original.setAttribute('aria-label', dialog.dataset.originalLabel + ': ' + original.textContent);
      if (activeKey) {
        var next = Array.from(list.querySelectorAll('button')).find(function (button) { return button.dataset.peekKey === activeKey && button.dataset.peekAction === activeAction && !button.disabled; });
        if (next) next.focus({preventScroll:true});
        else heading.querySelector('button').focus({preventScroll:true});
      }
    }
    function refresh() {
      if (window.FDGarage) { render(window.FDGarage.snapshot()); return; }
      if (lastCart) { render(lastCart); return; }
      var cached = window.FDPricing && window.FDPricing.snapshot();
      if (cached) { render(cached); return; }
      var version = ++requestVersion;
      status.textContent = dialog.dataset.loading;
      var request = window.FDPricing ? window.FDPricing.request.bind(window.FDPricing) : window.fetch.bind(window);
      request(dialog.dataset.cartUrl, {cache:'no-store', headers:{Accept:'application/json'}})
        .then(function (response) { if (!response.ok) throw new Error('Cart request failed'); return response.json(); })
        .then(function (cart) { if (version === requestVersion && !window.FDGarage) render(cart); else if (window.FDGarage) render(window.FDGarage.snapshot()); })
        .catch(function () { if (version === requestVersion && !lastCart) { status.textContent = dialog.dataset.error; retry.hidden = false; } });
    }
    list.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-peek-action]');
      if (!button || button.disabled || !window.FDGarage) return;
      var item = window.FDGarage.snapshot().items.find(function (line) { return line.key === button.dataset.peekKey; });
      if (!item) return;
      var quantity = button.dataset.peekAction === 'remove' ? 0 : item.quantity + (button.dataset.peekAction === 'increase' ? 1 : -1);
      window.FDGarage.change(item.key, quantity);
    });
    function finishClose() {
      window.clearTimeout(closeTimer);
      if (dialog.open) dialog.close();
    }
    function close(immediate) {
      if (!dialog.open) return;
      if (immediate === true || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finishClose(); return; }
      if (dialog.classList.contains('is-closing')) return;
      dialog.classList.add('is-closing');
      closeTimer = window.setTimeout(finishClose, 240);
    }
    dialog.addEventListener('animationend', function (event) {
      if (event.target === dialog && event.animationName === 'fd-cart-peek-out') finishClose();
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    toggle.addEventListener('click', function () {
      if (window.matchMedia('(min-width:1024px)').matches) return;
      if (dialog.open) { close(); return; }
      home = document.createComment('Buying bar return position');
      bar.before(home);
      heading.hidden = false; content.hidden = false;
      bar.classList.add('is-peek-open');
      bar.setAttribute('aria-live', 'off');
      dialog.append(bar);
      toggle.setAttribute('aria-expanded', 'true');
      toggle.querySelector('span').textContent = dialog.dataset.hide;
      dialog.showModal();
      document.documentElement.classList.add('fd-cart-peek-open');
      heading.querySelector('button').focus({preventScroll:true});
      refresh();
    });
    dialog.addEventListener('close', function () {
      window.clearTimeout(closeTimer);
      dialog.classList.remove('is-closing');
      ++requestVersion;
      // A breakpoint change may already have returned the bar to its new layout.
      if (dialog.contains(bar) && home && home.isConnected) home.after(bar);
      if (home) home.remove();
      heading.hidden = true; content.hidden = true;
      bar.classList.remove('is-peek-open');
      bar.setAttribute('aria-live', 'polite');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.querySelector('span').textContent = dialog.dataset.view;
      document.documentElement.classList.remove('fd-cart-peek-open');
      toggle.focus({preventScroll:true});
    });
    var backdropDown = false;
    dialog.addEventListener('pointerdown', function (event) { backdropDown = event.target === dialog; });
    dialog.addEventListener('click', function (event) { if (event.target === dialog && backdropDown) close(); });
    heading.querySelector('button').addEventListener('click', close);
    retry.addEventListener('click', refresh);
    // Preserve the existing checkout/upsell handler on the original button.
    checkout.addEventListener('click', function () { close(true); }, true);
    document.addEventListener('fd:garage-layout', function () { close(true); });
    document.addEventListener('fd:cart-preview', function (event) {
      ++requestVersion;
      render(event.detail.cart);
    });
    document.addEventListener('fd:cart-updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || !Array.isArray(cart.items)) return;
      ++requestVersion;
      render(window.FDGarage ? window.FDGarage.snapshot() : cart);
    });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
